import React, { useRef, useState, useEffect } from 'react'
import { db } from '../firebase-config'
import { collection, getDocs } from 'firebase/firestore'
import { CATEGORIES } from '../Tags'
import { ShopTemplate } from '../components/ShopTemplate'
import { Input } from '../components/Input'
import { Button } from '../components/Button'
import { Category } from '../components/Category'
import searchStyle from './Search.module.css'
import styles from './Home.module.css'
import categoryStyles from '../components/Category.module.css'
import { BsTriangleFill } from 'react-icons/bs'
import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax

mapboxgl.accessToken = process.env.REACT_APP_MAP_ACCESS_TOKEN

export const Search = () => {
  const mapContainer = useRef(null)
  const map = useRef(null)
  const userRef = collection(db, 'users')
  const [lng, setLng] = useState(13.05501)
  const [lat, setLat] = useState(47.80949)
  const [zoom, setZoom] = useState(11)
  const [shop, setShop] = useState()
  const [shops, setShops] = useState([])
  const [filteredShops, setFilteredShops] = useState([])
  const [streetTerm, setStreetTerm] = useState('')
  const [postcodeTerm, setPostcodeTerm] = useState('')
  const [placeTerm, setPlaceTerm] = useState('')
  const [radiusTerm, setRadiusTerm] = useState('')
  const [showCategories, setShowCategories] = useState(false)
  const [selectedCategories, setSelectedCategories] = useState([])

  const markerClick = (shop) => {
    setShop(shop)
    window.location = '#shop-container'
  }

  useEffect(() => {
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom: zoom,
    })
  }, [filteredShops, lng, lat, zoom])

  async function getShops() {
    const data = await getDocs(userRef)
    const parsedData = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    setShops(parsedData)
    setFilteredShops(parsedData)
  }

  function filterShops(selectedCategories) {
    let filtered = new Set()
    shops.forEach((shop) => {
      shop.categories.forEach((category) => {
        if (selectedCategories.includes(category)) {
          filtered.add(shop)
        }
      })
    })
    setFilteredShops([...filtered])
  }

  async function getGeo(streetname, postcode, place) {
    let country = ''
    if (place === '') {
      country = '&country=at'
    }
    const searchText = `${streetname}%20${postcode}%20${place}`
    const data = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${searchText}.json?access_token=${mapboxgl.accessToken}${country}`,
    )
    const parsedData = await data.json()
    return parsedData.features[0].center
  }

  async function saveGeo(street, postcode, place) {
    let geocoordinates
    if (street || postcode || place) {
      geocoordinates = await getGeo(street, postcode, place)
    }
    setLng(await geocoordinates[0])
    setLat(await geocoordinates[1])
  }

  useEffect(() => {
    getShops()
  }, [])

  useEffect(() => {
    filteredShops.forEach((shop) => {
      const marker = new mapboxgl.Marker()
      marker.setLngLat(shop.geocoordinates).addTo(map.current)
      marker.getElement().addEventListener('click', () => markerClick(shop))
    })
  }, [filteredShops, lng, lat, zoom])

  return (
    <>
      <div className={searchStyle.searchContainer}>
        <Input
          name="street"
          type="text"
          label="Straße Hausnummer"
          placeholder="Musterstraße 1"
          value={streetTerm}
          onChange={(e) => setStreetTerm(e.target.value)}
        />
        <Input
          name="postcode"
          type="text"
          label="Postleitzahl"
          placeholder="5020"
          value={postcodeTerm}
          onChange={(e) => setPostcodeTerm(e.target.value)}
        />
        <Input
          name="place"
          type="text"
          label="Ort"
          placeholder="Salzburg"
          value={placeTerm}
          onChange={(e) => setPlaceTerm(e.target.value)}
        />
        <Button
          onClick={() => {
            saveGeo(streetTerm, postcodeTerm, placeTerm)
          }}
        >
          Adresse suchen
        </Button>

        <Input
          name="radius"
          type="text"
          label="Suche nach Radius (km)"
          placeholder="20"
          value={radiusTerm}
          onChange={(e) => setRadiusTerm(e.target.value.replace(',', '.'))}
        />
        <Button
          onClick={() => {
            setZoom(Math.log(40000 / (radiusTerm * 3)) / Math.log(2))
          }}
        >
          Radius auswählen
        </Button>

        <h2
          id="category"
          className={searchStyle.closed}
          onClick={() => {
            setShowCategories(!showCategories)
            !showCategories
              ? document
                  .getElementById('category')
                  .classList.remove(`${searchStyle.closed}`)
              : document
                  .getElementById('category')
                  .classList.add(`${searchStyle.closed}`)
          }}
        >
          nach Kategorien filtern <BsTriangleFill />
        </h2>
        {showCategories && (
          <>
            <div className={categoryStyles.category_container}>
              {CATEGORIES.map((category) => {
                return (
                  <Category
                    key={category.id}
                    category={category}
                    isSelected={selectedCategories.includes(category.id)}
                    onCategoryClick={() => {
                      const currentCategory = selectedCategories.includes(
                        category.id,
                      )
                      if (currentCategory) {
                        setSelectedCategories(
                          selectedCategories.filter((id) => id !== category.id),
                        )
                      } else {
                        setSelectedCategories([
                          ...selectedCategories,
                          category.id,
                        ])
                      }
                    }}
                    variant="Small"
                  />
                )
              })}
            </div>
            <Button
              onClick={() => {
                filterShops(selectedCategories)
                setShowCategories(!showCategories)
              }}
            >
              Shops filtern
            </Button>
          </>
        )}
      </div>

      <div
        ref={mapContainer}
        className={`map-container ${searchStyle.search}`}
      />
      <div id="shop-container" className={styles.shop_container}>
        {shop && <ShopTemplate shop={shop} />}
      </div>
    </>
  )
}
